import { ReactNode } from 'react'
import { Card, CardContent, Typography, Stack } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined'
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined'

type NoteVariant = 'info' | 'warning' | 'tip' | 'danger'

interface NoteCardProps {
  title: string
  content: ReactNode
  variant?: NoteVariant
}

export function NoteCard({ variant = 'info', title, content }: NoteCardProps) {
  const variants: Record<NoteVariant, { color: string; icon: ReactNode }> = {
    info: {
      color: '#FF5E1E',
      icon: <InfoOutlinedIcon sx={{ color: '#FF5E1E' }} fontSize="small" />,
    },
    warning: {
      color: '#f59e0b', // TODO: checar se precisa mudar cores #f59e0b
      icon: <WarningAmberOutlinedIcon sx={{ color: '#f59e0b' }} fontSize="small" />,
    },
    tip: {
      color: '#10b981', // TODO: checar se precisa mudar cores #10b981
      icon: <TipsAndUpdatesOutlinedIcon sx={{ color: '#10b981' }} fontSize="small" />,
    },
    danger: {
      color: '#ef4444', // TODO: checar se precisa mudar cores #ef4444
      icon: <ReportGmailerrorredOutlinedIcon sx={{ color: '#ef4444' }} fontSize="small" />,
    },
  }

  const { color, icon } = variants[variant]

  return (
    <Card
      sx={{
        backgroundColor: '#FFF',
        color: '#FF5E1E',
        borderRadius: 2,
        border: '1px solid #FF5E1E',
        boxShadow: 'none',
        p: 1,
        mb: 2,
      }}
    >
      <CardContent sx={{ '&:last-child': { pb: 1.5 }, p: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          {icon}
          <Typography variant="subtitle1" sx={{ color, fontWeight: 700 }}>
            {title}
          </Typography>
        </Stack>
        {content}
      </CardContent>
    </Card>
  )
}
